<template>
  <div
    class="w-6 h-6"
    :style="{
      'width': `${size}px`,
      'height': `${size}px`,
    }"
  >
  <img
    ref="target"
    :data-src="lazyImg"
    :src="defaultImg"
    :alt="alt"
    class="rounded-full"
    v-if="!immediately"
  />
  <img
    v-else
    :src="lazyImg"
    :alt="alt"
    class="rounded-full"
  />
  </div>
</template>

<script setup>
  import { useIntersectionObserver } from '@vueuse/core';
  
  const { alt, size, lazyImg, defaultImg, immediately } = defineProps({
    "alt": {
      type: String,
    },
    "size": {
      type: String || Number,
    },
    "defaultImg": {
      type: String,
      default: "/static/jpg/flags-jpg/default-flag.jpg"
    },
    "lazyImg": {
      type: String,
      required: true,
    },
    "immediately": {
      type: Boolean,
      default: false,
    }
  });

  const target = ref(null);

  onMounted(() => {
    if (!immediately) {
      useIntersectionObserver(
        target,
        (entries, observer) => {
          entries.map(entry => {
            if (entry?.isIntersecting || entry.intersectionRatio > 0) {
                const img = entry.target;
                const src = img.getAttribute('data-src');
                img.setAttribute('src', src);
                img.removeAttribute('data-src');
                observer.disconnect();
            }
          });
        },
      );
    }
  });

</script>
<style lang="scss" scoped>

</style>